// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-list-container{background-color:#fefefe;position:fixed}.message-list-container.toolbar-height-sm{height:calc(100% - 112px);top:56px}.message-list-container.toolbar-height-md{height:calc(100% - 96px);top:48px}.message-list-container.toolbar-height-lg{height:calc(100% - 128px);top:64px}#lex-web[ui-minimized]{background:#0000}html{font-size:14px!important}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
